import axios from 'axios';
import { API_URL } from './api';

export interface WorkOSProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  emailVerified: boolean;
  profilePictureUrl?: string;
}

export interface WorkOSAuthorizationResponse {
  success: boolean;
  authorizationUrl: string;
}

export const workosService = {
  /**
   * Get the WorkOS authorization URL from the backend
   * @param organization - Optional organization identifier
   * @returns The authorization URL to redirect the user to
   */
  getAuthorizationUrl: async (organization?: string, frontendOrigin?: string): Promise<string> => {
    try {
      const params = {
        ...(organization ? { organization } : {}),
        ...(frontendOrigin ? { frontendOrigin } : {}),
      };
      const response = await axios.get<WorkOSAuthorizationResponse>(
        `${API_URL}/auth/workos/authorize`,
        { params }
      );
      
      if (response.data.success && response.data.authorizationUrl) {
        return response.data.authorizationUrl;
      }
      
      throw new Error('Failed to get authorization URL');
    } catch (error: any) {
      console.error('Error getting WorkOS authorization URL:', error);
      throw new Error(
        error.response?.data?.message || 
        'Failed to initialize SSO authentication'
      );
    }
  },

  /**
   * Get the WorkOS user profile using the current session cookie.
   */
  getProfile: async (): Promise<WorkOSProfile> => {
    try {
      const response = await axios.get<WorkOSProfile>(
        `${API_URL}/auth/workos/profile`,
        { withCredentials: true }
      );
      
      return response.data;
    } catch (error: any) {
      console.error('Error getting WorkOS profile:', error);
      throw new Error(
        error.response?.data?.message || 
        'Failed to get user profile'
      );
    }
  },
};

